import { Reveal } from '@/components/ui/Reveal'

const steps = [
  {
    desc: 'Enter your city or locality to instantly see all nearby turfs with live availability.',
    n: '1',
    title: 'Search your area',
  },
  {
    desc: 'Browse real-time availability and tap the time that works best for you.',
    n: '2',
    title: 'Pick your slot',
  },
  {
    desc: 'Secure UPI, debit, credit or wallet payment. Booking confirmed in seconds.',
    n: '3',
    title: 'Pay instantly',
  },
  {
    desc: 'Show your booking QR at the gate and get straight onto the pitch.',
    n: '4',
    title: 'Chale, khelo!',
  },
]

export function HowItWorks() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-20" id="how">
      <SectionLabel>How it works</SectionLabel>
      <Reveal delay={0.05}>
        <h2
          className="font-display font-bold leading-[1.1] tracking-tight mb-14"
          style={{
            color: 'var(--text)',
            fontSize: 'clamp(1.9rem,3.5vw,2.8rem)',
            letterSpacing: '-.5px',
            maxWidth: 520,
          }}
        >
          From search to kickoff
          <br />
          in under 3 minutes
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 relative">
        {/* Dashed connector — desktop only */}
        <div
          className="hidden lg:block absolute top-5 left-[12%] right-[12%] h-px"
          style={{
            background:
              'repeating-linear-gradient(90deg,var(--lime-line) 0,var(--lime-line) 8px,transparent 8px,transparent 16px)',
          }}
        />
        {steps.map((s, i) => (
          <Reveal className="text-center relative z-10" delay={i * 0.1} key={s.n}>
            <div
              className="w-10 h-10 mx-auto mb-5 rounded-full flex items-center justify-center font-display font-bold text-[0.85rem]"
              style={{
                background: 'var(--bg)',
                border: '1.5px solid rgba(184,236,60,.35)',
                color: 'var(--lime)',
              }}
            >
              {s.n}
            </div>
            <div className="text-[0.95rem] font-semibold mb-2" style={{ color: 'var(--text)' }}>
              {s.title}
            </div>
            <div
              className="text-[0.82rem] font-light leading-relaxed"
              style={{ color: 'var(--muted)' }}
            >
              {s.desc}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  )
}

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <Reveal
      className="flex items-center gap-3 text-[0.7rem] font-bold tracking-[0.14em] uppercase mb-3"
      style={{ color: 'var(--lime)' }}
    >
      <span className="block w-5 h-px" style={{ background: 'var(--lime)' }} />
      {children}
    </Reveal>
  )
}
